import React from "react";
import { Modal, notification, PageHeader } from "antd";
import { getOriginators, saveOriginator, deleteOriginator, getCurrentCustomer } from "api/api";
import "./ManageOriginatorsPage.scss";
import { displayGenericError } from "common/notifications";
import {getOrderStatusByOriginatorId, renewAccessToken} from "../../api/api";
import {displayError} from "../../common/notifications";
import {DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE_10} from "../../common/Const";
import OriginatorsTable from "../../components/OriginatorsTable";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

const confirm = Modal.confirm;

class ManageOriginatorsPage extends React.Component {
  state = {
    originators: null,
    isLoading: true,
    currentCustomer: {},
    pagination:{
      current: DEFAULT_PAGE_NO,
      size: DEFAULT_PAGE_SIZE_10
    },

  };

  onAddNewOriginatorClicked = () => {
    this.setState({
      originatorModalVisible: true,
      addNewOriginatorActiveTab: "originatorInformationTab"
    });
  };

  closeOriginatorModal = () => {
    this.setState({
      originatorModalVisible: false
    });
  };

  addNewOriginatorNextClicked = () => {
    this.setState({
      addNewOriginatorActiveTab: "bankAccountTab"
    });
  };

  addNewOriginatorBackClicked = () => {
    this.setState({
      addNewOriginatorActiveTab: "originatorInformationTab"
    });
  };

  deleteOriginator = originator => {
    const intl = this.props.useIntl;
    let canDelete = true;
    getOrderStatusByOriginatorId(originator.id)
        .then(response => {
          for (let orderStatus in response) {
            if (response[orderStatus] == "BOOKING"
                || response[orderStatus] == "PROCESSING"
                ||  response[orderStatus] == "DRAFT") {
              canDelete = false;
              break;
            }
          }
          if (!canDelete) {
            displayError(intl.formatMessage({id: "app.message.manageoriginatorspage.deletesendernotallowed"}));
          } else {
            confirm({
              title: intl.formatMessage({id: "app.message.manageoriginatorspage.deletesender"}),
              onOk: () => {
                this.setState({
                  isLoading: true
                });
                deleteOriginator(originator.id)
                    .then(response => {
                      notification.success({
                        message: "Brdgx",
                        description: intl.formatMessage({id: "app.message.manageoriginatorspage.senderdeleted"})
                      });
                      this.setState({
                        isLoading: false
                      });
                      this.refreshOriginatorsList(this.state.pagination.current);
                    })
                    .catch(error => {
                      displayGenericError(error);
                      this.setState({
                        isLoading: false
                      });
                    });
              }
            });
          }
        })
        .catch(error => {
          displayGenericError(error);
          this.setState({
            isLoading: false
          });
        });

  };

  submitOriginator = originator => {
    const intl = this.props.useIntl;
    saveOriginator(originator)
      .then(response => {
        notification.success({
          message: "Brdgx",
          description: intl.formatMessage({id: "app.message.manageoriginatorspage.senderadded"})
        });
        this.setState({
          originatorModalVisible: false,
          originator: {}
        });
        this.refreshOriginatorsList(this.state.pagination.current);
      })
      .catch(error => {
        displayError(intl.formatMessage({id: "app.message.manageoriginatorspage.couldnotsavesender"}));
      });
  };

  refreshOriginatorsList = (currentPage) => {
    const intl = this.props.useIntl;
    if(currentPage && currentPage>0) {
      currentPage=currentPage-1;
    }else {
      currentPage = 0;
    }
    let pagination = this.state.pagination;
    this.setState({
      isLoading: true,
    });
    getOriginators(currentPage, DEFAULT_PAGE_SIZE_10)
      .then(response => {
        pagination.total = response.totalElements;
        pagination.current = currentPage+1;

        this.setState({
          isLoading: false,
          originators: response.content,
          pagination: pagination
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          originators: []
        });
        displayError(intl.formatMessage({id: "app.message.manageoriginatorspage.couldnotloadsenders"}));
      });
  };
  renewAccessToken =() =>{
    const intl = this.props.useIntl;
    renewAccessToken( localStorage.getItem("ACCESS_TOKEN")).then(response=>{
      localStorage.setItem("ACCESS_TOKEN", response.accessToken);
    }).catch(error=>{
      if(error.status === 401){
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.handleLogout("/","success", intl.formatMessage({id: "app.message.sessiontimeout"}));
      }
    })
  }
  componentDidMount() {
    this.renewAccessToken();
    this.setState({
      isLoading: true
    });
    this.refreshOriginatorsList(DEFAULT_PAGE_NO);
    getCurrentCustomer().then(response=>{
      this.setState({
        currentCustomer: response
      });
    });
  }

  onChangePage(pagination){
    let nextPage = pagination.current;
    this.refreshOriginatorsList(nextPage);

  }

  onOriginatorCreated = () => {
    this.setState({
      originatorModalVisible: false
    });
    this.refreshOriginatorsList(0);
  };

  updateOriginator = (idx,newOrg) =>{
    let originators = this.state.originators;
    originators[idx] = newOrg;
    this.setState({
      originators:originators
    })
  }

  onOriginatorSearch =(originator) =>{
    var array = [];
    array.push(originator);

    let pagination = this.state.pagination;
    pagination.total = 1;
    pagination.current = 1;

    this.setState({
      originators: array,
      pagination: pagination,
      isLoading: false
    });

  }

  render() {
    const intl = this.props.useIntl;
    return (
      <div>
        <CustomRxPageHeader customer={this.props.customer}
            title={intl.formatMessage({id: "app.sidebar.managesenders"})}
        />
        <div className="bp-page-content bp-page-large">

          <OriginatorsTable
            className="originatorsTable"
            data={this.state.originators}
            pagination = {this.state.pagination}
            onChangePage = {(ev) => this.onChangePage(ev)}
            isLoading={this.state.isLoading}
            onAddNewOriginatorClicked={this.onAddNewOriginatorClicked}
            onDeleteOriginatorClicked={this.deleteOriginator}
            onOriginatorSearch={this.onOriginatorSearch}
            onRefresh={this.refreshOriginatorsList}
            currentCustomer={this.state.currentCustomer}
            updateOriginator={(idx,newOrg) => this.updateOriginator(idx,newOrg)}
          />
        </div>
        
      </div>
    );
  }
}

export default withUseIntl(ManageOriginatorsPage);